// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductFilter__container","shopContainer":"ProductFilter__shopContainer","pagination":"ProductFilter__pagination"};